import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const BotTerminal = ({
  logs = [],
  speed = '0 p/s',
  statusText = 'IDLE (Ожидание)',
  statusColor = '#ffffff',
  packetsSent = 0,
  sessionTime = '00:00',
  promptHost = 'hypixel',
  onClearLogs,
  onCopyLogs,
  onExecuteCommand,
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const [cmdInput, setCmdInput] = useState('');
  const logBodyRef = useRef(null);

  // Auto-scroll on new log entries
  useEffect(() => {
    if (logBodyRef.current) {
      logBodyRef.current.scrollTop = logBodyRef.current.scrollHeight;
    }
  }, [logs]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = cmdInput.trim();
    if (!trimmed) return;
    setCmdInput('');
    onExecuteCommand?.(trimmed);
  };

  return (
    <section>
      <div className="section-mono-header">
        <div className="section-mono-title">
          <svg viewBox="0 0 24 24" fill="none">
            <polyline points="4 17 10 11 4 5" />
            <line x1="12" y1="19" x2="20" y2="19" />
          </svg>
          <span>{isEn ? 'BOT LOG & NETWORK CONSOLE' : 'ЖУРНАЛ БОТА & СЕТЕВАЯ КОНСОЛЬ'}</span>
        </div>
      </div>

      <div className="terminal-card">
        {/* Terminal Header */}
        <div className="terminal-header">
          <div className="terminal-left-wrap">
            <div className="terminal-window-dots hidden sm:flex">
              <span className="t-dot red"></span>
              <span className="t-dot yellow"></span>
              <span className="t-dot green"></span>
            </div>
            <div className="terminal-title-text">
              <span className="hidden sm:inline">
                {isEn ? 'BOT NETWORK CONSOLE LOG' : 'ЖУРНАЛ СЕТЕВОЙ КОНСОЛИ БОТА'}
              </span>
              <span className="sm:hidden">
                {isEn ? 'BOT LOG' : 'КОНСОЛЬ'}
              </span>
            </div>
          </div>

          <div className="terminal-header-tools">
            <button
              type="button"
              className="t-tool-btn"
              onClick={onClearLogs}
              title={isEn ? 'Clear console' : 'Очистить консоль'}
            >
              {isEn ? 'Clear' : 'Очистить'}
            </button>
            <button
              type="button"
              className="t-tool-btn"
              onClick={onCopyLogs}
              title={isEn ? 'Copy logs' : 'Копировать'}
            >
              {isEn ? 'Copy' : 'Копировать'}
            </button>
          </div>
        </div>

        {/* Real-time Metrics Bar */}
        <div className="terminal-metrics-bar">
          <div className="t-metric-item">
            <span className="t-metric-label">{isEn ? 'Packet Rate' : 'Скорость пакетов'}</span>
            <span className="t-metric-value">{speed}</span>
          </div>
          <div className="t-metric-item">
            <span className="t-metric-label">{isEn ? 'Bot Status' : 'Статус бота'}</span>
            <span className="t-metric-value" style={{ color: statusColor }}>
              {statusText}
            </span>
          </div>
          <div className="t-metric-item">
            <span className="t-metric-label">{isEn ? 'Packets Sent' : 'Отправлено пакетов'}</span>
            <span className="t-metric-value">{packetsSent.toLocaleString()}</span>
          </div>
          <div className="t-metric-item">
            <span className="t-metric-label">{isEn ? 'Session Time' : 'Время сессии'}</span>
            <span className="t-metric-value">{sessionTime}</span>
          </div>
        </div>

        {/* Terminal Logs Output */}
        <div className="terminal-body" ref={logBodyRef}>
          {logs.map((log, index) => {
            const tag = log.tagType || 'system';
            return (
              <div key={index} className="log-line">
                <span className="log-time">{log.time}</span>
                <span className={`log-tag ${tag}`}>[{tag.toUpperCase()}]</span>
                <span className="log-text">{log.text}</span>
              </div>
            );
          })}
        </div>

        {/* Interactive Shell Box */}
        <div className="interactive-shell-box">
          <form className="shell-input-form" onSubmit={handleSubmit}>
            <span className="shell-prompt">
              <span className="shell-prompt-full">bot@{promptHost}:~$</span>
              <span className="shell-prompt-short">bot:~$</span>
            </span>
            <input
              type="text"
              className="shell-input"
              value={cmdInput}
              onChange={(e) => setCmdInput(e.target.value)}
              placeholder={
                isEn
                  ? 'Command (/help, /say, /attack)...'
                  : 'Команда (/help, /say, /attack)...'
              }
              autoComplete="off"
              spellCheck="false"
            />
            <button
              type="submit"
              className="shell-send-btn !text-black"
              style={{ color: '#000000' }}
            >
              <span className="!text-black shell-send-text-full" style={{ color: '#000000' }}>
                {isEn ? 'Execute' : 'Выполнить'}
              </span>
              <span className="!text-black shell-send-text-short" style={{ color: '#000000' }}>
                {isEn ? 'Run' : 'OK'}
              </span>
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2.2"
                style={{ stroke: '#000000' }}
                className="!stroke-black"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BotTerminal;
